import React from "react";

import { LetsWorkHome } from "./LetsWorkHome";
import NoiseFitCaseStudy from "./Portfolio/NoiseFitCaseStudy";
import DomainsGrid from "../component/DomainsGrid";
import FeaturedProject from "../component/FeaturedProject";
import Sameto from "../component/Sameto";
import MVPSection from "../component/MVPSection";
import EnquiryForm from "./Portfolio/EnquiryForm";
import TechExpertise from "./Portfolio/TechExpertise";



const Home = () => {
  return (
    <div className="pt-20">
      <LetsWorkHome />
      <NoiseFitCaseStudy />
      <DomainsGrid />
      <FeaturedProject />
      <Sameto />
      <MVPSection />
      <TechExpertise />
      <EnquiryForm padding="p-4 md:p-8" />
    </div>
  );
};

export default Home;
